import { render, staticRenderFns } from "./StructureBlockMetadataNodeView.vue?vue&type=template&id=774bf672"
import script from "./StructureBlockMetadataNodeView.vue?vue&type=script&lang=js"
export * from "./StructureBlockMetadataNodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports